import React from 'react';

const RescoreTestModal = ({
	showModal,
	testKey,
	testType,
	form,
	isRescoring,
	error,
	onChange,
	onClose,
	onSubmit,
}) => {
	if (!showModal) {
		return null;
	}

	const usesGrade = ['child-screening', 'youth-screening'].includes(testType);
	const gradeOptions =
		testType === 'child-screening'
			? [2, 3, 4, 5, 6, 7]
			: testType === 'youth-screening'
				? [8, 9, 10]
				: [];

	const testTypeText =
		{
			'child-screening': 'Screeningtest for barn',
			'youth-screening': 'Screeningtest for ungdom',
			'adult-screening': 'Screeningtest for voksne',
		}[testType] || testType;

	return (
		<div className="rescore-modal">
			<div className="rescore-modal__overlay" onClick={onClose} />

			<div
				className="rescore-modal__content"
				role="dialog"
				aria-modal="true"
				aria-labelledby="rescore-modal-title"
			>
				<h2 id="rescore-modal-title" className="rescore-modal__title">
					Skår testen på nytt
				</h2>

				<p className="rescore-modal__description">
					Some further message from Regine here...
				</p>
				<p className="rescore-modal__warning">
					Ny skåring erstatter testens eksisterende skårer.
				</p>

				<div className="rescore-modal__field">
					<label htmlFor="rescore-test-key">Testnøkkel</label>

					<input
						id="rescore-test-key"
						type="text"
						value={testKey || ''}
						readOnly
					/>
				</div>

				<div className="rescore-modal__field">
					<label htmlFor="rescore-test-type">Testtype</label>

					<input
						id="rescore-test-type"
						type="text"
						value={testTypeText}
						readOnly
					/>
				</div>

				<div className="rescore-modal__field">
					<label htmlFor="rescore-gender">Kjønn</label>

					<select
						id="rescore-gender"
						value={form.gender}
						onChange={(e) => onChange('gender', e.target.value)}
					>
						<option value="">Velg kjønn</option>

						<option value="m">Mann</option>

						<option value="f">Kvinne</option>
					</select>
				</div>
				{usesGrade && (
					<div className="rescore-modal__field">
						<label htmlFor="rescore-grade">Klassetrinn</label>

						<select
							id="rescore-grade"
							value={form.grade}
							onChange={(e) => onChange('grade', e.target.value)}
						>
							<option value="">Velg klassetrinn</option>

							{gradeOptions.map((grade) => (
								<option key={grade} value={String(grade)}>
									{grade}. trinn
								</option>
							))}
						</select>
					</div>
				)}

				<div className="rescore-modal__field">
					<label htmlFor="rescore-foreign">Språkstatus</label>

					<select
						id="rescore-foreign"
						value={form.isForeign}
						onChange={(e) => onChange('isForeign', e.target.value)}
					>
						<option value="0">Norsk som førstespråk</option>

						<option value="1">Norsk som andrespråk</option>
					</select>
				</div>

				{error && <div className="rescore-modal__error">{error}</div>}

				<div className="rescore-modal__actions">
					<button
						type="button"
						className="rescore-modal__button rescore-modal__button--secondary"
						onClick={onClose}
						disabled={isRescoring}
					>
						Avbryt
					</button>

					<button
						type="button"
						className="rescore-modal__button rescore-modal__button--primary"
						onClick={onSubmit}
						disabled={isRescoring}
					>
						{isRescoring ? 'Skårer...' : 'Skår på nytt'}
					</button>
				</div>
			</div>
		</div>
	);
};

export default RescoreTestModal;
